import { create, v, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import debounce from 'lodash-es/debounce';
import { TextInput } from '@dojo/widgets/text-input';
import { Icon } from '@dojo/widgets/icon';
import { nls } from '../support/glossary-nls';
const icache = createICacheMiddleware();
const factory = create({ icache, nls }).properties();
export const Toolbar = factory(({ properties, middleware: { icache, nls } }) => {
    const { messages: { alphabet, numbers, search } } = nls();
    const { usedletters, selected, themedCss, select_letter, do_search } = properties();
    const used = icache.getOrSet('used', () => new Set(Object.keys(usedletters)));
    const buttons = Array.from(alphabet).map((letter) => {
        const isSelected = letter === selected;
        const isInvalid = !used.has(letter);
        return v('button', {
            classes: [
                themedCss.alphabutton,
                themedCss.touch,
                isSelected ? themedCss.selectedbutton : null,
                isInvalid ? themedCss.invalidbutton : null
            ],
            disabled: isInvalid,
            ...formatAriaProperties({ pressed: `${isSelected}` }),
            onclick: (event) => {
                event && event.stopPropagation();
                !isInvalid && select_letter(letter);
                icache.set('search', '');
            }
        }, [letter]);
    });
    buttons.push(v('button', {
        classes: [themedCss.numberbutton, themedCss.touch, themedCss.invalidbutton],
        disabled: true,
        ...formatAriaProperties({ pressed: 'false' }),
        onclick: (event) => {
            event && event.stopPropagation();
        }
    }, [numbers]), w(TextInput, {
        kind: 'outlined',
        placeholder: search,
        value: icache.getOrSet('search', ''),
        onValue: (val) => {
            icache.set('search', val);
            if (val.length >= 3) {
                debounce(() => do_search(val), 500)();
            }
        }
    }, [
        {
            label: search,
            trailing: w(Icon, { type: 'searchIcon' })
        }
    ]));
    return v('div', { classes: [themedCss.toolbar] }, buttons);
});
